import {
    initDropMenuTool as initDropMenuToolFromSDK,
    initSideBarTool as initSideBarToolFromSDK,
} from '@baidu/ku-tool-sdk/dist/extension-loader';
import type {IKuToolSDKInstance} from '../types';
import type {InitSideBarParams, InitDropMenuParams} from '../types/slot';

export enum ToolErrorCode {
    ToolIdNotMatch = 1,
    LoadError = 2,
}

export function getErrorMsg(code: ToolErrorCode): string {
    switch (code) {
        case ToolErrorCode.ToolIdNotMatch:
            return '工具 ID 不匹配';
        case ToolErrorCode.LoadError:
            return 'JS 地址加载失败';
        default:
            return '未知错误';
    }
}

export const isDevKuTool = process.env.REACT_APP_DEV_KU_TOOL === 'true';

/**
 * 初始化侧边栏工具
 *
 * @param component 组件
 * @param id 工具 ID
 * @throws 如果工具 ID 为空，则抛出错误
 */
export function initSideBarTool(
    sdk: IKuToolSDKInstance,
    params: InitSideBarParams
) {
    initSideBarToolFromSDK(sdk as any, params);
}

/**
 * 初始化下拉菜单工具
 *
 * @param param0 初始化下拉菜单工具所需参数
 * @param param0.id 工具的唯一标识符
 * @param param0.name 工具的名称
 * @param param0.icon 工具的图标
 * @param param0.onClick 工具被点击时触发的回调函数
 * @param param0.toggleVisibility 工具的可见性切换函数
 * @throws 如果 id 或 name 为 undefined，则抛出错误
 */
export function initDropMenuTool(
    sdk: IKuToolSDKInstance,
    params: InitDropMenuParams
) {
    initDropMenuToolFromSDK(sdk as any, params);
}
